import Select from 'antd/lib/select'
import { BlockComponentFactory } from 'shared/express-interface/blocks-core/BlockFactory'
import { useBlockState } from 'shared/express-interface/blocks-core/BlockHooks'

type SelectBlockProps = {
    options: {
        label: string
        value: string
    }[]
    dropdownStyle?: React.CSSProperties
    initialValue?: string
}

export const SelectBlockComponent = BlockComponentFactory.createBlockComponent<SelectBlockProps>(
    props => {
        const [selectedValue, setSelectedValue] = useBlockState<string>(
            'selectedValue',
            props.initialValue
        )
        return (
            <Select
                data-testid="select-block"
                options={props.options}
                style={props.style ?? { width: 160 }}
                value={selectedValue?.value}
                dropdownStyle={
                    props.dropdownStyle ?? {
                        padding: '0px',
                        borderRadius: '4px',
                        border: '1px solid #F7F7F8',
                    }
                }
                onChange={(value: string) => {
                    setSelectedValue(value)
                }}
                placement="bottomRight"
            />
        )
    }
)
